export default {
  init() {
    // JavaScript to be fired on the about us page
    var a = document.getElementById('phoneno'),
    b = document.getElementById('phoneno1'),
    c = document.getElementById('phoneno2');
   
   var matches;
    a.onkeyup = function() {
      matches = this.value.match(/\d+/g); 
        if (matches[0].length === parseInt(this.attributes['maxlength'].value)) {
            b.focus();
        }
    }

    b.onkeyup = function() {
      matches = this.value.match(/\d+/g); 
        if (matches[0].length === parseInt(this.attributes['maxlength'].value)) {
            c.focus();
        }
    }
      },
};



// WEBPACK FOOTER //
// ./scripts/routes/exhibitRequest.js